import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import SectionMixin from 'component/sections/base/section-mixin';
import SectionFallbackMixin from 'component/sections/base/section-fallback-mixin';
import SimpleContentMixin from 'component/sections/common/simple-content-base/simple-content-mixin';
import { deviceBenchmark } from 'utils/device-benchmark';
import { map, lerp } from '@resn/gozer-math';
import { easings } from '@resn/gozer-animation';

import getStore from 'core/store';
import { COLORS } from 'core/constants';
const store = getStore();

@componentMixin(DomComponentMixin)
@componentMixin(deviceBenchmark.fallback ? SectionFallbackMixin : SectionMixin)
@componentMixin(SimpleContentMixin)
class HomeDiscoverXP1 extends Component {
    props = {};

    options = {
        customC: true,

        btnData: {
            textColor: 'white',
            bgColor: COLORS.LIGHT_BLUE,
        },
    };

    update() {
        const { mobile, scale } = store.state;
        const { scroll, bounds, viewport } = this.props;

        if (mobile) return;

        const yDist = 1200 * scale;
        const yPr = map(
            scroll,
            bounds.top - viewport.height - 1000 * scale,
            bounds.top - viewport.height + bounds.height,
            0,
            1,
            true,
        );

        const y = lerp(easings.easeOutSine(yPr), -yDist, 0);

        this.ui.inner.style.transform = `translateY(${y}px)`;
    }
}

export default HomeDiscoverXP1;
